import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ORDER_SHIPMENT_INFO_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { NseStatus, OrderShipmentInfo } from './order-shipment-info';

@Injectable({
  providedIn: 'root',
})
export class OrderShipmentInfoService {
  constructor(
    @Inject(ORDER_SHIPMENT_INFO_SERVICE_URL) private serviceUrl: string,
    private http: HttpClient
  ) {}

  getOrderShipmentInfo(orderNumber: string): Observable<OrderShipmentInfo> {
    return this.http.get<OrderShipmentInfo>(`${this.serviceUrl}/${encodeURIComponent(orderNumber)}`);
  }

  getNseStatus(barcode: string): Observable<NseStatus> {
    return this.http.get<NseStatus>(`${this.serviceUrl}/nse-status/${encodeURIComponent(barcode)}`);
  }
}
